module.exports = __webpack_public_path__ + "static/media/sopt17ru.bd8206b2.pdf";